// extracted by mini-css-extract-plugin
module.exports = {"input":"StudentInfoInputField_input__1iEVh"};